import { AfterViewChecked, ChangeDetectorRef, Component, NgZone, OnInit } from '@angular/core';
import { RegistrationResponse } from '../login/registration-response';
import { ToastmessageService } from './toastmessage.service';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
    selector: 'lib-toastmessage',
    templateUrl: './toastmessage.component.html',
    styleUrls: ['./toastmessage.component.scss'],
    animations: [
        trigger('toastMessageTrigger', [
            state('open', style({ transform: 'translateY(0%)' })),
            state('close', style({ transform: 'translateY(-200%)' })),
            transition('open <=> close', [animate('300ms ease-in-out')])
        ])
    ]
})
export class ToastmessageComponent implements OnInit {
    response: RegistrationResponse = {};

    toastClass?: string[];
    toastMessage?: string;
    showsToast?: boolean;

    constructor(public _toastmessageService: ToastmessageService) {}

    ngOnInit(): void {

    }

    dismiss(): void {
        this._toastmessageService.dismissToast();
      }
}
